import imageCompression from 'browser-image-compression'

export async function compressPicture(file, type = 'Passport') {
    let options

    switch (type) {
        case 'Signature': //For signatures, we use a smaller size
            options = {
                maxSizeMB: 0.05,
                maxWidthOrHeight: 300,
                useWebWorker: true,
            }
            break

        case 'Cover': //For cover images, we allow a larger size
            options = {
                maxSizeMB: 0.3,
                maxWidthOrHeight: 1280,
                useWebWorker: true,
            }
            break
        case 'Document': //For documents, we allow a larger size
            options = {
                maxSizeMB: 0.35,           
                maxWidthOrHeight: 1000,    
                useWebWorker: true,
            }
                break

        case 'Passport': //For passport photos, we use a moderate size
        default:
            options = {
                maxSizeMB: 0.1,
                maxWidthOrHeight: 600,
                useWebWorker: true,
            }
            break
    }

    try {
        const compressed = await imageCompression(file, options)

        // const compressedSizeKB = (compressed.size / 1024).toFixed(2)
        // const reduction = (((file.size - compressed.size) / file.size) * 100).toFixed(1)

        // console.log(`📂 Compression Result [${type}]:`)
        // console.log(`➡️ Original: ${originalSizeKB} KB | ${file.name} (${file.type})`)
        // console.log(`✅ Compressed: ${compressedSizeKB} KB | ${compressed.name || 'blob'} (${compressed.type})`)
        // console.log(`📉 Reduction: ${reduction}%`)
        
        return compressed
    } catch (err) {
        console.error('Image compression failed:', err)
        throw err
    }
}
